import { MockServiceStore } from "./MockServiceStore";

/**
 * StructureCast - Casting Group
 */
export interface StructureCastCastingGroup {
  id: string;
  projectId: string;
  groupNumber: number;
  name: string;
  startDate: string;
  endDate: string;
  status: "planning" | "active" | "completed";
  notes: string;
  createdAt: string;
  updatedAt: string;
}

export const mockStructureCastCastingGroups: StructureCastCastingGroup[] = [
  {
    id: "sc-cg-1",
    projectId: "sc-proj-1",
    groupNumber: 1,
    name: "Heritage Ranch — Deep Manholes",
    startDate: "2026-01-19",
    endDate: "2026-01-20",
    status: "completed",
    notes: "SSMH-01 (8.5') + SSMH-02 (7.5') — 48\" sanitary MH with full stack: base + riser + eccentric cone + grade ring. 2 structures, 8 components.",
    createdAt: "2025-11-15T00:00:00.000Z",
    updatedAt: "2026-01-20T00:00:00.000Z",
  },
  {
    id: "sc-cg-2",
    projectId: "sc-proj-1",
    groupNumber: 2,
    name: "Heritage Ranch — Standard Manholes",
    startDate: "2026-01-26",
    endDate: "2026-01-28",
    status: "active",
    notes: "SSMH-03 + SSMH-04 + SSMH-05 — Nacimiento Lake Dr / Heritage Loop sanitary main. 3 structures, 12 components. Mix of 24\" + 12\" risers, 36\" + 24\" eccentric cones.",
    createdAt: "2025-11-15T00:00:00.000Z",
    updatedAt: "2026-01-26T00:00:00.000Z",
  },
  {
    id: "sc-cg-3",
    projectId: "sc-proj-1",
    groupNumber: 3,
    name: "Heritage Ranch — Mid-Depth Manholes",
    startDate: "2026-02-02",
    endDate: "2026-02-03",
    status: "planning",
    notes: "SSMH-06 + SSMH-07 — Cabrillo Way / Lakeview Dr. 2 structures, 7 components. 24\" eccentric cones, mixed grade rings.",
    createdAt: "2025-11-15T00:00:00.000Z",
    updatedAt: "2025-12-01T00:00:00.000Z",
  },
  {
    id: "sc-cg-4",
    projectId: "sc-proj-1",
    groupNumber: 4,
    name: "Heritage Ranch — Shallow Manholes",
    startDate: "2026-02-09",
    endDate: "2026-02-10",
    status: "planning",
    notes: "SSMH-08 + SSMH-09 — Lakeview Dr / Pinion Trail shallow manholes. 2 structures, 6 components. No risers, just base + 24\" eccentric cone + 2\" grade ring.",
    createdAt: "2025-11-15T00:00:00.000Z",
    updatedAt: "2025-12-01T00:00:00.000Z",
  },
];

export const createMockStructureCastCastingGroupStore = () =>
  new MockServiceStore<StructureCastCastingGroup>({
    mockData: mockStructureCastCastingGroups,
    idField: "id",
    simulateDelay: 200,
    persistKey: "preferred-structurecast-casting-groups",
  });

export default mockStructureCastCastingGroups;
